module.exports = __webpack_public_path__ + "img/harpia_logo_alt.f916d7a7.png";